document.addEventListener('DOMContentLoaded',function(){
  // desktop mega toggle (mobile uses drawer instead)
  document.querySelectorAll('.navitem').forEach(function(it){
    var mega=it.querySelector('.mega'); if(!mega)return;
    var t=it.querySelector('.top'); if(!t)return;
    t.addEventListener('click',function(e){
      if(window.matchMedia('(max-width:900px)').matches){e.preventDefault();mega.classList.toggle('open');}
    });
  });
  // mobile drawer
  var burger=document.querySelector('.m-burger');
  var drawer=document.getElementById('mdrawer');
  var overlay=document.getElementById('moverlay');
  var closeBtn=document.querySelector('.m-close');
  function openD(){if(drawer){drawer.classList.add('open');overlay.classList.add('open');document.body.style.overflow='hidden';}}
  function closeD(){if(drawer){drawer.classList.remove('open');overlay.classList.remove('open');document.body.style.overflow='';}}
  if(burger)burger.addEventListener('click',function(e){e.preventDefault();openD();});
  if(overlay)overlay.addEventListener('click',closeD);
  if(closeBtn)closeBtn.addEventListener('click',closeD);
  document.querySelectorAll('.m-toggle').forEach(function(t){
    t.addEventListener('click',function(e){e.preventDefault();t.parentElement.classList.toggle('open');});
  });

  // product page: variant switch + quantity stepper + stock
  var vs=document.getElementById('variant-select');
  var priceEl=document.getElementById('price');
  var stockEl=document.getElementById('stock');
  var atc=document.getElementById('atc');
  var qty=document.getElementById('qty');
  function updVariant(){
    if(!vs)return; var o=vs.options[vs.selectedIndex]; if(!o)return;
    if(priceEl)priceEl.textContent=o.getAttribute('data-price');
    var _img=document.getElementById('main-image'); var _di=o.getAttribute('data-image'); if(_img&&_di){_img.src=_di;}
    if(stockEl){
      if(o.getAttribute('data-available')!=='true'){stockEl.textContent='Ausverkauft';stockEl.className='stock out';}
      else if(o.getAttribute('data-low')==='true'){stockEl.textContent='Nur noch '+o.getAttribute('data-qty')+' verfügbar!';stockEl.className='stock low';}
      else {stockEl.textContent='Auf Lager';stockEl.className='stock in';}
    }
    if(atc)atc.disabled=(o.getAttribute('data-available')!=='true');
    if(qty){var mx=o.getAttribute('data-max'); if(mx){qty.max=mx; if(+qty.value>+mx)qty.value=mx;} else {qty.removeAttribute('max');}}
  }
  if(vs)vs.addEventListener('change',updVariant);
  var qm=document.querySelector('.qminus'), qp=document.querySelector('.qplus');
  if(qm&&qty)qm.addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value)||1)-1);});
  if(qp&&qty)qp.addEventListener('click',function(){var mx=qty.max?parseInt(qty.max):Infinity;qty.value=Math.min(mx,(parseInt(qty.value)||1)+1);});


  // ===== cart page: remove + quantity stepper (auto-update via Cart AJAX) =====
  var cartTimers={};
  function cartChange(line, qty){
    var el=document.querySelector('.cart-line[data-line="'+line+'"]');
    if(el)el.classList.add('updating');
    fetch(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root+'cart/change.js':'/cart/change.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({line:parseInt(line),quantity:qty})
    }).then(function(){window.location.reload();}).catch(function(){window.location.reload();});
  }
  document.querySelectorAll('.cart-line').forEach(function(el){
    var line=el.getAttribute('data-line');
    var val=el.querySelector('.cq-val');
    var rm=el.querySelector('.cl-remove');
    var minus=el.querySelector('.cq-minus');
    var plus=el.querySelector('.cq-plus');
    function schedule(q){
      val.value=q; clearTimeout(cartTimers[line]);
      el.classList.add('updating');
      cartTimers[line]=setTimeout(function(){cartChange(line,q);},450);
    }
    if(rm)rm.addEventListener('click',function(){cartChange(line,0);});
    if(minus)minus.addEventListener('click',function(){var q=Math.max(1,(parseInt(val.value)||1)-1);schedule(q);});
    if(plus)plus.addEventListener('click',function(){var q=(parseInt(val.value)||1)+1;schedule(q);});
  });

});
